/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deck_Error_SaveInputs */



/**
* | output |
* | --- |
* | "Couldn't save the deck." |
*
* @param {Deck_Error_SaveInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const deck_error_save = /** @type {((inputs?: Deck_Error_SaveInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deck_Error_SaveInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Impossible d'enregistrer le deck.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pudo guardar el mazo.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Não foi possível salvar o deck.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile salvare il mazzo.")
	return /** @type {LocalizedString} */ ("Couldn't save the deck.")
});